<div class="classification-indicator" id="indicator" [dir]="data.dir">
    <formio-loader></formio-loader>
    <br />
    <br />
    <div class="container">
        <div class="add-new" setRtl>
            <ng-container *ngIf="data.isSummary;else details">
                <lib-section [title]="('forms.common.indicatorSummary' | translate) + ' - ' + (data.indicator.name)">
                </lib-section>
            </ng-container>
            <ng-template #details>
                <lib-section [title]="(data.indicator.code ? data.indicator.code + ' - ' : '') + data.indicator.name">
                </lib-section>
            </ng-template>
            <div class="custom-tooltip" *ngIf="data.indicator.tooltip" (click)="showDialog(data.indicator.tooltip)">
                <i class="fa fa-info"></i>
            </div>
            <p>{{data.indicator.description}}</p>
            <div *ngIf="data.indicator.hasError" class="error">
                {{data.indicator.error}}
            </div>

            <mat-accordion>
                <mat-expansion-panel *ngFor="let domain of data.indicator.domains;let domainIndex = index" #expansion
                    hideToggle (opened)="loadDomainQuestions(domain)">
                    <mat-expansion-panel-header [class.borderInlineStart]="domain.hasComments">
                        <mat-panel-title>
                            <div class="title-container">
                                <div>{{domain.code }}
                                    <span class="separator"></span>
                                    {{domain.name}}
                                    <span class="separator"></span>
                                    <span>{{'forms.common.completionRate' | translate}} (<span [countUp]="domain.completionRate"></span> %)</span>
                                </div>
                                <div class="status-container">
                                    <div class="circle-tooltip" *ngIf="domain.tooltip"
                                        (click)="$event.stopPropagation();showDialog(domain.tooltip)">
                                        <i class="fa fa-info"></i>
                                    </div>
                                    <app-indicator-status class="status" [status]="domain.decision">
                                    </app-indicator-status>
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>{{domain.description}}</p>
                    <div class="error" *ngIf="domain.hasError">{{domain.error}}</div>
                    <div class="warning" *ngIf="!data.options.disableQuestions">
                        {{'forms.common.Please check and save all items of the second and third levels' | translate}}
                    </div>
                    <br />

                    <ng-container *ngIf="!data.options.hideQuestions && !data.isSummary">
                        <div>
                            <ng-container *ngFor="let question of domain.questions;let questionIndex = index">
                                <app-classification-indicator-question [orginalQuestion]="question"
                                    [domain]="orginalDomains[domainIndex]" [dir]="data.dir" [data]="data"
                                    [indicator]="data.indicator"
                                    [attachmentsFormKey]="data.indicator.attachmentsFormKey"
                                    [viewOnly]="data.options.disableQuestions || domain.decision == indicatorStatus.Complete"
                                    (loading)="changeLoading($event)"
                                    (dataChanged)="questionDataChanged($event,questionIndex,domainIndex)"
                                    (onHistoryUpdated)="historyUpdated(questionIndex,domainIndex)">
                                </app-classification-indicator-question>
                                <br />
                            </ng-container>
                        </div>
                        <br />
                    </ng-container>

                    <ng-container
                        *ngIf="!data.options.hideAttachments && !data.isSummary && ready && domain.hasAttachments">
                        <div class="card attachment-container">
                            <div class="header">
                                <label class="label" [class.field-required]="domain.attachmentIsRequired">
                                    {{domain.attachmentName | translate}}
                                </label>
                                <i class="fas fa-info-circle iconTooltip" *ngIf="domain.attachmentsTooltip"
                                    [pTooltip]="domain.attachmentsTooltip"></i>
                            </div>

                            <formio #forms [id]="domain._id"
                                [style.margin-top]="data.options.disableQuestions || domain.decision == indicatorStatus.Complete? '-45px' : '-65px'"
                                [loadingFormHidden]="false"
                                [submission]="{data:{attachments : domain.attachmentsFiles }}"
                                [formKey]="data.indicator.attachmentsFormKey" [showLoader]="false"
                                (formLoad)="formLoad($event)"
                                [readOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Complete"
                                [viewOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Complete">
                            </formio>
                        </div>
                    </ng-container>
                    <br />

                    <ng-container *ngIf="!data.options.hideDecision">
                        <div class="card">
                            <label class="m-b-5">{{'forms.common.domainDecision' | translate}}</label>
                            <div class="radioContainer">
                                <div class="content">
                                    <input class="radio m-end" type="radio" [value]="indicatorStatus.UnComplete"
                                        [(ngModel)]="domainsDecisions[domainIndex]"
                                        name="decision_{{domain._id}}_notComplete"
                                        id="decision_{{domain._id}}_notComplete"
                                        [disabled]="data.options.disableDecision || data.isSummary">
                                    <label for="decision_{{domain._id}}_notComplete">{{'forms.common.no' |
                                        translate}}</label>
                                </div>
                                <div class="content">
                                    <input class="radio m-end" type="radio" [value]="indicatorStatus.Complete"
                                        [(ngModel)]="domainsDecisions[domainIndex]"
                                        name="decision_{{domain._id}}_completed" id="decision_{{domain._id}}_completed"
                                        [disabled]="data.options.disableDecision || data.isSummary">
                                    <label for="decision_{{domain._id}}_completed">{{'forms.common.yes' |
                                        translate}}</label>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!data.options.hideNotesAndRecommendations && ready">
                        <br />
                        <div class="card">
                            <label class="m-b-5"
                                [class.field-required]="domainsDecisions[domainIndex] == indicatorStatus.UnComplete">
                                {{'forms.common.detective notes & recommendations' | translate}}
                            </label>

                            <formio [id]="'notesAndRecommendations_' + domain._id" [loadingFormHidden]="false"
                                [style.margin-top]="data.options.disableNotesAndRecommendations || data.isSummary? '-25px' : '-50px'"
                                [submission]="{data:{notesAndRecommendations : domain.notesAndRecommendations }}"
                                [formKey]="data.indicator.domainNotesAndRecommendationsFormKey" [showLoader]="false"
                                (formLoad)="formLoad($event)"
                                [readOnly]="data.options.disableNotesAndRecommendations || data.isSummary"
                                [viewOnly]="data.options.disableNotesAndRecommendations || data.isSummary">
                            </formio>
                            <mat-error
                                *ngIf="domainsDecisions[domainIndex] == indicatorStatus.UnComplete && !domain.notesAndRecommendations?.length">
                                {{'forms.common.You must add at least one item' | translate}}
                            </mat-error>
                        </div>
                        <br />
                    </ng-container>

                    <div style="text-align: end;"
                        *ngIf="!data.options.hideSaveDomain && !data.isSummary && (!data.options.hideDecision||(data.options.hideDecision && domainsDecisions[domainIndex] != indicatorStatus.Complete))">
                        <button class="dialog-button dialog-save" (click)="save(domainIndex,expansion);"
                            [disabled]="!domain.isValid || formioLoader.loading || (domainsDecisions[domainIndex] == null && !data.options.hideDecision) || (domainsDecisions[domainIndex] == indicatorStatus.UnComplete && (!domain.notesAndRecommendations?.length))">
                            {{'forms.common.Save Domain' | translate}}
                        </button>
                    </div>

                    <br />
                </mat-expansion-panel>
            </mat-accordion>

            <br />
            <br />
            <div [style.textAlign]="data.isSummary ? 'center' : 'end'">
                <button class="dialog-button dialog-cancel" (click)="close()">
                    {{'forms.common.back' | translate}}
                </button>

                <ng-container *ngIf="data.isSummary && !data.options.hideSaveDomain">
                    <button class="dialog-button dialog-save" (click)="updateDomains(true)"
                        [disabled]="formioLoader.loading">
                        {{'forms.common.updateAllDomains' | translate}}
                    </button>
                    <button class="dialog-button dialog-update" (click)="updateDomains()"
                        [disabled]="formioLoader.loading">
                        {{'forms.common.updateNotCompletedDomains' | translate}}
                    </button>
                </ng-container>

            </div>
        </div>
    </div>
    <br />
    <br />

    <div class="info-hint" *ngIf="!data.options.disableQuestions">
        <div>
            <span class="hasChange"></span>
            {{'forms.common.Not saved' | translate}}
        </div>
        <div>
            <span class="hasError"></span>
            {{'forms.common.Error' | translate}}
        </div>
        <div>
            <span class="hasComments"></span>
            {{'forms.common.Has comment' | translate}}
        </div>
    </div>
</div>